import type { IconDefinition } from '../index.tsx';

export const iconCircleNotch: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCircleNotch',
  icon: [
    512,
    512,
    [],
    '',
    'M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z',
  ],
};
